"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconQuestionWidgetBase = exports.SimplifiedCustomDatePickerWidget = exports.PluginTemplates = exports.PageValidationMessage = exports.AutomaticRenewalCancellationConfirmationModal = exports.InfoModal = exports.ConfirmModal = exports.AutoRenewalBenefits = exports.WebChatPopUp = exports.PolicySummaryPriceWidget = exports.DocumentListModal = void 0;
var core_1 = require("@athena-portal/core");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@ferry/journey-services");
var GuardErrorPage_1 = require("./pages/GuardErrorPage");
var FalconJourneyRenderingPage_1 = require("./pages/FalconJourneyRenderingPage");
var ApplicationErrorPage_1 = require("./pages/ApplicationErrorPage");
var motor_1 = require("./widgets/annual/motor");
var Types_1 = require("./Types");
var ChangelogRecorder_1 = require("./services/ChangelogRecorder");
var FalconCommandsExecutor_1 = require("./services/FalconCommandsExecutor");
var motor_2 = require("./commands/annual/motor");
var commands_1 = require("./commands");
var motorCommon_1 = require("./widgets/motorCommon");
var payments_1 = require("./widgets/payments");
var navigator_1 = require("./navigator");
var directDebit_1 = require("./widgets/directDebit");
var widgets_1 = require("./widgets");
var DocumentListModal_1 = require("./widgets/annual/motor/DocumentListModal");
Object.defineProperty(exports, "DocumentListModal", { enumerable: true, get: function () { return DocumentListModal_1.DocumentListModal; } });
var PolicySummaryPriceWidget_1 = require("./widgets/PolicySummaryPriceWidget");
Object.defineProperty(exports, "PolicySummaryPriceWidget", { enumerable: true, get: function () { return PolicySummaryPriceWidget_1.PolicySummaryPriceWidget; } });
var WebChatPopUp_1 = require("./components/modals/WebChatPopUp");
Object.defineProperty(exports, "WebChatPopUp", { enumerable: true, get: function () { return WebChatPopUp_1.WebChatPopUp; } });
var AutoRenewalBenefits_1 = require("./helpers/AutoRenewalBenefits");
Object.defineProperty(exports, "AutoRenewalBenefits", { enumerable: true, get: function () { return AutoRenewalBenefits_1.AutoRenewalBenefits; } });
var ConfirmModal_1 = require("./components/modals/ConfirmModal");
exports.ConfirmModal = ConfirmModal_1.default;
var InfoModal_1 = require("./components/modals/InfoModal");
Object.defineProperty(exports, "InfoModal", { enumerable: true, get: function () { return InfoModal_1.InfoModal; } });
var AutomaticRenewalCancellationConfirmationModal_1 = require("./components/modals/AutomaticRenewalCancellationConfirmationModal");
Object.defineProperty(exports, "AutomaticRenewalCancellationConfirmationModal", { enumerable: true, get: function () { return AutomaticRenewalCancellationConfirmationModal_1.AutomaticRenewalCancellationConfirmationModal; } });
var PageValidationMessage_1 = require("./helpers/PageValidationMessage");
Object.defineProperty(exports, "PageValidationMessage", { enumerable: true, get: function () { return PageValidationMessage_1.PageValidationMessage; } });
var PluginTemplates_1 = require("./PluginTemplates");
Object.defineProperty(exports, "PluginTemplates", { enumerable: true, get: function () { return PluginTemplates_1.PluginTemplates; } });
var SimplifiedCustomDatePickerWidget_1 = require("./widgets/SimplifiedCustomDatePickerWidget");
Object.defineProperty(exports, "SimplifiedCustomDatePickerWidget", { enumerable: true, get: function () { return SimplifiedCustomDatePickerWidget_1.SimplifiedCustomDatePickerWidget; } });
var banners_1 = require("./widgets/banners");
var FalconQuestionWidgetBase_1 = require("./widgets/FalconQuestionWidgetBase");
Object.defineProperty(exports, "FalconQuestionWidgetBase", { enumerable: true, get: function () { return FalconQuestionWidgetBase_1.FalconQuestionWidgetBase; } });
var plugin = {
    getName: function () {
        return "plugin-ferry-journey";
    },
    register: function (extensions, configuration) {
        // Routes
        extensions.routes.rebind({
            path: "/journey/:action/product/:product/process/:process/:pageId?/:interactionId?",
            component: FalconJourneyRenderingPage_1.FalconPluginJourneyRenderingPage,
        });
        // Widgets
        (0, widgets_1.addBaseWidgets)(extensions);
        (0, motor_1.addAnnualMotorWidgets)(extensions);
        (0, motorCommon_1.addCommonMotorWidgets)(extensions);
        (0, payments_1.addPaymentsWidgets)(extensions);
        (0, directDebit_1.addDirectDebitWidgets)(extensions);
        (0, banners_1.addBannerWidgets)(extensions);
        // Services
        extensions.services.bind(journey_services_1.Types.CacheManager).to(journey_services_1.FalconCacheManager).inSingletonScope();
        extensions.services.bind(journey_services_1.Types.FalconConvenienceApiService).to(journey_services_1.FalconConvenienceApiServiceImpl);
        extensions.services.bind(journey_services_1.Types.FalconConvenienceApiServiceConfig).toConstantValue(configuration.falconConvenienceApiService);
        extensions.services.rebind(plugin_journey_1.Types.LookupService).to(journey_services_1.FalconLookupService);
        // Navigators
        (0, navigator_1.addNavigators)(extensions);
        // Commands
        (0, motor_2.addAnnualMotorCommands)(extensions);
        (0, commands_1.addCommonCommands)(extensions);
        extensions.routes.add({
            path: "/keycloakFeedback",
            component: GuardErrorPage_1.GuardErrorPage,
        });
        extensions.routes.add({
            path: "/error",
            component: ApplicationErrorPage_1.ApplicationErrorPage,
        });
        extensions.routes.rebind({
            path: "/sessionExpired",
            component: GuardErrorPage_1.GuardErrorPage,
        });
        extensions
            .services
            .bind(journey_services_1.Types.NotificationService)
            .to(journey_services_1.NotificationService)
            .inSingletonScope();
        extensions
            .services
            .bind(Types_1.Types.ChangelogRecorder)
            .to(ChangelogRecorder_1.ChangelogRecorder)
            .inSingletonScope();
        extensions
            .services
            .rebind(plugin_journey_1.Types.CommandsExecutor)
            .to(FalconCommandsExecutor_1.FalconCommandsExecutor)
            .inSingletonScope();
        (0, journey_services_1.registerValidators)(extensions.services.get(core_1.TypeDefs.JourneyComponentsManager));
    },
};
exports.default = plugin;
__exportStar(require("./widgets/SectionPanelTags"), exports);
__exportStar(require("./widgets/annual/motor/DocumentListModal"), exports);
__exportStar(require("./commonFunctions"), exports);
__exportStar(require("./widgets/annual/motor/directDebit/DirectDebitFunctions"), exports);
__exportStar(require("./widgets/annual/motor/WolfMTADeclineTextOutputWidget"), exports);
__exportStar(require("./widgets/annual/motor/WolfRenewalMTADeclineOutputTextWidget"), exports);
//# sourceMappingURL=index.js.map